module.exports = require("./ks");